import React, {useContext} from "react";
import {CurrentContext, SetterContext} from "../App";
import ConfigTextCheckboxButton from "./elements/ConfigTextCheckboxButton";

function TextCheckboxButtonGroup(props: {
    fullwidth?: true;
    name: string;
    elements: string[],
    heading?: string,
    featureList?: any[],
    images?: any[],
    amount?: (undefined | {
        min: number,
        max: number
    })[]
}) {
    const Current = useContext(CurrentContext);
    const set = useContext(SetterContext)(props.name);

    const toggleElement = (key: string) => {
        let elements = Current[props.name];

        if (elements.includes(key)) {
            set(elements.filter((e: string) => e !== key));
        } else {
            set(elements.concat([key]));
        }
    };

    return <div className="flex category-container" id="fahrzeug-laenge">
        {props.heading && <div className="flex category-title">{props.heading}</div>}
        <div className="flex button-area" id="fahrzeug-laenge-buttons">
            {props.elements.map(
                    (v, i) =>
                            <ConfigTextCheckboxButton
                                    fullwidth={props.fullwidth}
                                    value={v}
                                    key={v}
                                    name={props.name}
                                    selected={Current[props.name].includes(v)}
                                    callback={() => toggleElement(v)}
                                    image={props.images?.[i]}
                                    amount={props.amount?.[i]}
                            />
                    ,
            )}

        </div>
        {
                props.featureList && <>
                    <div className="flex vertical-line"></div>
                    <div className="flex paket-content" id="fahrzeug-paket-inhalt">
                        {props.featureList[props.elements.indexOf(Current[props.name])]}
                    </div>
                </>}
    </div>;
}

export default TextCheckboxButtonGroup;
